import { FormSubmitButton, LoadingIndicator } from "@indietabletop/appkit";
import type { RecipeVariants } from "@vanilla-extract/recipes";
import { button } from "../../common/common.css.ts";

export function FormDialogSubmitButton(
  props: {
    children: string;
  } & RecipeVariants<typeof button>,
) {
  const { theme, maxInlineSize, marginInline, size, mask, children } = props;

  return (
    <FormSubmitButton
      loading={<LoadingIndicator />}
      className={button({
        theme,
        size: size ?? "small",
        mask: mask ?? 1,
        maxInlineSize: maxInlineSize ?? "15x",
        marginInline: marginInline ?? "auto",
      })}
    >
      {children}
    </FormSubmitButton>
  );
}
